import React from "react";

import { HighlightRange, IProductTemplateAttribute } from "components/dashboard/product-template-table/utils/interfaces";
import { InputNumber } from "primereact/inputnumber";
import { T } from "services/lang/LanguageService";
import OutputHighlight from "./components/OutputHighlight";

type DatasetTypeProps = {
  attribute: IProductTemplateAttribute;
  onAttrChangeInDataset: React.Dispatch<React.SetStateAction<IProductTemplateAttribute>>;
};

const DatasetType: React.FC<DatasetTypeProps> = ({ attribute, onAttrChangeInDataset }) => {
  const bgHighlightList = [...(attribute.bgHighlightRanges ?? [])];
  const updateAttributeChange = (newBgList: HighlightRange[]) => {
    onAttrChangeInDataset(prev => ({
      ...prev,
      bgHighlightRanges: newBgList,
    }));
  };
  return (
    <>
      <OutputHighlight bgHighlights={bgHighlightList} onAttributeChange={updateAttributeChange} />
      <div className=" p-field p-col-2">
        <label>{T("config.decimal-places")}</label>
        <InputNumber
          placeholder={T("message.number-of-decimal-places-to-show")}
          value={attribute.decimalPlaces}
          onChange={e => onAttrChangeInDataset(prev => ({ ...prev, decimalPlaces: e.value ?? 2 }))}
          name="decimalPlaces"
          className="p-inputtext-sm"
        />
      </div>
    </>
  );
};

export default DatasetType;
